import { gql } from "@apollo/client";


export const POST_SAVE_PRECIOS_MASIVOS = gql`
    mutation MGuardarPreciosMasivos($listaCostosInsumos: [CostoInsumoModelInput!]!){
        saveCostoInsumoMasivo(listaCostosInsumos: $listaCostosInsumos) 
        {
            success,
            error,
            valorEsperado
        }
}`;

// grabar insumo
export const POST_SAVE_INSUMO = gql`
    mutation MGuardarInsumo($producto: ProductoModelInput!
            $listaAlergias: [ProductoAlergiaModelInput!]!, 
            $listaCompatibilidades: [ProductoCompatibilidadModelInput!]!, 
            $listaTecnologiasMedicas: [ProductoTecnologiaMedicaModelInput!]!,
            $listaTipoAccesos: [ProductoTipoAccesoModelInput!]!,
            $listaInsumosCaja: [InsumoCajaModelInput!]!,
            $listaCostos: [CostoInsumoModelInput!]!,
            $listaProgramas: [InsumoProgramaModelInput!]!){
        saveProducto(model: {
            producto: $producto,
            listaAlergias: $listaAlergias,
            listaCompatibilidades: $listaCompatibilidades,
            listaTecnologiasMedicas: $listaTecnologiasMedicas,
            listaTipoAccesos: $listaTipoAccesos,
            listaInsumosCaja: $listaInsumosCaja,
            listaCostos: $listaCostos,
            listaProgramas: $listaProgramas
        }) {
            success,
            error,
            valorEsperado
        }
}`;